export default (timeout, checkInterval, callback) => {
    let lastActionTime = Date.now()

    setInterval(() => {
        const now = Date.now()
        const last = lastActionTime
        if (now - last > timeout) {
            lastActionTime = Date.now()
            callback()
        }
    }, checkInterval)

    // detect activity by touchstart
    document.addEventListener('touchstart', () => {
        lastActionTime = Date.now()
    })
    // if not touch, check for clicks
    if (!('ontouchstart' in window)) {
        document.addEventListener('click', () => {
            lastActionTime = Date.now()
        })
    }
}
